import { AttachmentService } from '@addins/media';
import { Component, Input } from '@angular/core';
import { Task } from '@models/imported/SagaSchema/Task';
import { TasksProviderService } from '../../services/tasks-provider/tasks-provider.service';

@Component({
  selector: 'app-task-add-attachment-button',
  templateUrl: './task-add-attachment-button.component.html',
  styleUrls: ['./task-add-attachment-button.component.scss']
})
export class TaskAddAttachmentButton {
  @Input()
  task: Task;

  get isMyTask(): boolean {
    return this.tasksProvider.myTask && this.tasksProvider.myTask.ObjGuid == this.task.ObjGuid;
  }

  constructor(private tasksProvider: TasksProviderService, private attachmentService: AttachmentService) {}

  onAddAttachmentClicked() {
    this.attachmentService.createAttachment(this.task.ObjGuid);
  }
}
